import React from 'react';

import { Header as RadarHeader } from '@radar-ui/header';
import Logo from 'images/dimensions-logo.svg';

const SharedHeader = ({ children, className }) => {
    return (
        <RadarHeader
            className={className}
            logo={Logo}
            logoAlt="Dimensions"
            renderLogo={(logo, alt) => (
                <a href="https://www.dimensions.ai/" target="_blank" rel="noopener noreferrer">
                    <img width={180} src={logo} alt={alt} />
                </a>
            )}
        >
            {children}
        </RadarHeader>
    );
};

export default SharedHeader;
